(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'contentPlainImages', {
            bindings: {
                content:    '<',
                imageClass: '@'
            },
            templateUrl:  'app/views/partials/content/content-plain-images.html',
            controllerAs: 'vm',

            renderingOptions: {
                'content-plain-images': {
                    inputs:    [
                        'content="::content.asset_contents"',
                        'image-class="{{::content.asset_contents.imagesVariant}}"'
                    ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>',
                    classes:   [ 'block-container' ]
                }
            }
        });
})();
